<template>
    <div class="col-md-6 m-b">
        <div v-bind:class="[error,'form-group']">
            <label>{{ name }}</label>
            <select class="form-control" :name="'dynamic_field_'+id" :title="name" v-model="value_inner">
                <option value="1">{{ t_yes }}</option>
                <option value="0">{{ t_no }}</option>
            </select>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['id', 'name', 'value', 'error'],
        data: function() {
            return {
                t_yes: Lang.langGet("Yes"),
                t_no: Lang.langGet("No"),
                value_inner: this.value
            }
        },
        watch: {
            value_inner: function(val,oldVal){
                this.$emit('input',val);
            }
        }
    }


</script>
